/* ====================================
*            ANGULAR IMPORTS
======================================= */

import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

/* ====================================
*            CUSTOM IMPORTS
======================================= */

import { AuthLayoutComponent } from "./components/auth-layout/auth-layout.component";
import { LoginPageComponent } from "./components/login-page/login-page.component";
import { PasswordResetComponent } from "./components/password-reset/password-reset.component";
import { RequestPasswordResetComponent } from "./components/request-password-reset/request-password-reset.component";

// * CUSTOM

const routes = [
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      { path: "", component: LoginPageComponent },
      // {
      //   path: 'request-password-reset',
      //   component: RequestPasswordResetComponent,
      // },
      // {
      //   path: 'password-reset',
      //   component: PasswordResetComponent,
      // },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {}
